import * as Types from '../../generated-types';

import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
export type CreateOrGetQueryVariables = Types.Exact<{
  user: Types.Scalars['ID'];
  date: Types.Scalars['Date'];
}>;


export type CreateOrGetQuery = { __typename?: 'Query', createOrGet?: { __typename?: 'DayEntityResponse', data?: { __typename?: 'Day', documentId: string, date?: any | null, vacation?: boolean | null, isSick?: boolean | null, totalHoursOff?: number | null, punches: Array<{ __typename?: 'Punch', documentId: string, in?: any | null, out?: any | null, location: string, pendingPunches: Array<{ __typename?: 'PendingPunch', documentId: string, oldIn?: any | null, oldOut?: any | null, in?: any | null, out?: any | null, approved?: boolean | null, createdAt?: any | null } | null> } | null>, user?: { __typename?: 'UsersPermissionsUser', documentId: string } | null, hoursOff: Array<{ __typename?: 'HoursOff', documentId: string, from?: any | null, to?: any | null } | null> } | null } | null };

export type GetDaysByUserQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID'];
  startDate: Types.Scalars['Date'];
  endDate: Types.Scalars['Date'];
}>;


export type GetDaysByUserQuery = { __typename?: 'Query', days: Array<{ __typename?: 'Day', documentId: string, date?: any | null, vacation?: boolean | null, isSick?: boolean | null, totalHoursOff?: number | null, punches: Array<{ __typename?: 'Punch', documentId: string, in?: any | null, out?: any | null, location: string, pendingPunches: Array<{ __typename?: 'PendingPunch', documentId: string, oldIn?: any | null, oldOut?: any | null, in?: any | null, out?: any | null, approved?: boolean | null, createdAt?: any | null } | null> } | null>, hoursOff: Array<{ __typename?: 'HoursOff', documentId: string, from?: any | null, to?: any | null } | null>, user?: { __typename?: 'UsersPermissionsUser', documentId: string } | null } | null> };

export type GetVacationsPerMonthQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date'];
  endDate: Types.Scalars['Date'];
}>;


export type GetVacationsPerMonthQuery = { __typename?: 'Query', days: Array<{ __typename?: 'Day', documentId: string, date?: any | null, user?: { __typename?: 'UsersPermissionsUser', documentId: string, firstName: string, lastName: string, color?: string | null } | null } | null> };

export type GetHoursOffPerMonthQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date'];
  endDate: Types.Scalars['Date'];
}>;


export type GetHoursOffPerMonthQuery = { __typename?: 'Query', days: Array<{ __typename?: 'Day', documentId: string, date?: any | null, user?: { __typename?: 'UsersPermissionsUser', documentId: string, firstName: string, lastName: string, color?: string | null } | null, hoursOff: Array<{ __typename?: 'HoursOff', documentId: string, from?: any | null, to?: any | null } | null> } | null> };

export type GetUsersWorkingTodayQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date'];
  endDate: Types.Scalars['Date'];
}>;


export type GetUsersWorkingTodayQuery = { __typename?: 'Query', working: Array<{ __typename?: 'Day', documentId: string, date?: any | null, user?: { __typename?: 'UsersPermissionsUser', documentId: string, firstName: string, lastName: string, blocked?: boolean | null, color?: string | null } | null } | null>, onVacation: Array<{ __typename?: 'Day', documentId: string, date?: any | null, user?: { __typename?: 'UsersPermissionsUser', documentId: string, firstName: string, lastName: string, blocked?: boolean | null, color?: string | null } | null } | null>, withHoursOff: Array<{ __typename?: 'Day', documentId: string, date?: any | null, user?: { __typename?: 'UsersPermissionsUser', documentId: string, firstName: string, lastName: string, blocked?: boolean | null, color?: string | null } | null, hoursOff: Array<{ __typename?: 'HoursOff', documentId: string, from?: any | null, to?: any | null } | null> } | null> };


export const CreateOrGetDocument = `
    query createOrGet($user: ID!, $date: Date!) {
  createOrGet(user: $user, date: $date) {
    data {
      documentId
      date
      vacation
      isSick
      totalHoursOff
      punches(pagination: {limit: -1}) {
        documentId
        in
        out
        location
        pendingPunches(pagination: {limit: -1}) {
          documentId
          oldIn
          oldOut
          in
          out
          approved
          createdAt
        }
      }
      user {
        documentId
      }
      hoursOff(pagination: {limit: -1}) {
        documentId
        from
        to
      }
    }
  }
}
    `;
export const useCreateOrGetQuery = <
      TData = CreateOrGetQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: CreateOrGetQueryVariables,
      options?: UseQueryOptions<CreateOrGetQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<CreateOrGetQuery, TError, TData>(
      ['createOrGet', variables],
      fetcher<CreateOrGetQuery, CreateOrGetQueryVariables>(client, CreateOrGetDocument, variables, headers),
      options
    );

useCreateOrGetQuery.getKey = (variables: CreateOrGetQueryVariables) => ['createOrGet', variables];
;

export const GetDaysByUserDocument = `
    query getDaysByUser($userId: ID!, $startDate: Date!, $endDate: Date!) {
  days(
    filters: {user: {documentId: {eq: $userId}}, date: {gte: $startDate, lte: $endDate}}
    pagination: {limit: -1}
  ) {
    documentId
    date
    vacation
    isSick
    totalHoursOff
    punches(pagination: {limit: -1}) {
      documentId
      in
      out
      location
      pendingPunches(pagination: {limit: -1}) {
        documentId
        oldIn
        oldOut
        in
        out
        approved
        createdAt
      }
    }
    hoursOff(pagination: {limit: -1}) {
      documentId
      from
      to
    }
    user {
      documentId
    }
  }
}
    `;
export const useGetDaysByUserQuery = <
      TData = GetDaysByUserQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetDaysByUserQueryVariables,
      options?: UseQueryOptions<GetDaysByUserQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetDaysByUserQuery, TError, TData>(
      ['getDaysByUser', variables],
      fetcher<GetDaysByUserQuery, GetDaysByUserQueryVariables>(client, GetDaysByUserDocument, variables, headers),
      options
    );

useGetDaysByUserQuery.getKey = (variables: GetDaysByUserQueryVariables) => ['getDaysByUser', variables];
;

export const GetVacationsPerMonthDocument = `
    query getVacationsPerMonth($startDate: Date!, $endDate: Date!) {
  days(
    filters: {vacation: {eq: true}, date: {gte: $startDate, lte: $endDate}}
    pagination: {limit: -1}
  ) {
    documentId
    date
    user {
      documentId
      firstName
      lastName
      color
    }
  }
}
    `;
export const useGetVacationsPerMonthQuery = <
      TData = GetVacationsPerMonthQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetVacationsPerMonthQueryVariables,
      options?: UseQueryOptions<GetVacationsPerMonthQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetVacationsPerMonthQuery, TError, TData>(
      ['getVacationsPerMonth', variables],
      fetcher<GetVacationsPerMonthQuery, GetVacationsPerMonthQueryVariables>(client, GetVacationsPerMonthDocument, variables, headers),
      options
    );

useGetVacationsPerMonthQuery.getKey = (variables: GetVacationsPerMonthQueryVariables) => ['getVacationsPerMonth', variables];
;

export const GetHoursOffPerMonthDocument = `
    query getHoursOffPerMonth($startDate: Date!, $endDate: Date!) {
  days(
    filters: {hoursOff: {documentId: {null: false}}, date: {gte: $startDate, lte: $endDate}}
    pagination: {limit: -1}
  ) {
    documentId
    date
    user {
      documentId
      firstName
      lastName
      color
    }
    hoursOff(pagination: {limit: -1}) {
      documentId
      from
      to
    }
  }
}
    `;
export const useGetHoursOffPerMonthQuery = <
      TData = GetHoursOffPerMonthQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetHoursOffPerMonthQueryVariables,
      options?: UseQueryOptions<GetHoursOffPerMonthQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetHoursOffPerMonthQuery, TError, TData>(
      ['getHoursOffPerMonth', variables],
      fetcher<GetHoursOffPerMonthQuery, GetHoursOffPerMonthQueryVariables>(client, GetHoursOffPerMonthDocument, variables, headers),
      options
    );

useGetHoursOffPerMonthQuery.getKey = (variables: GetHoursOffPerMonthQueryVariables) => ['getHoursOffPerMonth', variables];
;

export const GetUsersWorkingTodayDocument = `
    query getUsersWorkingToday($startDate: Date!, $endDate: Date!) {
  working: days(
    filters: {vacation: {eq: false}, date: {gte: $startDate, lte: $endDate}, punches: {documentId: {null: false}}}
    pagination: {limit: -1}
  ) {
    documentId
    date
    user {
      documentId
      firstName
      lastName
      blocked
      color
    }
  }
  onVacation: days(
    filters: {vacation: {eq: true}, date: {gte: $startDate, lte: $endDate}}
    pagination: {limit: -1}
  ) {
    documentId
    date
    user {
      documentId
      firstName
      lastName
      blocked
      color
    }
  }
  withHoursOff: days(
    filters: {hoursOff: {documentId: {null: false}}, date: {gte: $startDate, lte: $endDate}}
    pagination: {limit: -1}
  ) {
    documentId
    date
    user {
      documentId
      firstName
      lastName
      blocked
      color
    }
    hoursOff(pagination: {limit: -1}) {
      documentId
      from
      to
    }
  }
}
    `;
export const useGetUsersWorkingTodayQuery = <
      TData = GetUsersWorkingTodayQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUsersWorkingTodayQueryVariables,
      options?: UseQueryOptions<GetUsersWorkingTodayQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUsersWorkingTodayQuery, TError, TData>(
      ['getUsersWorkingToday', variables],
      fetcher<GetUsersWorkingTodayQuery, GetUsersWorkingTodayQueryVariables>(client, GetUsersWorkingTodayDocument, variables, headers),
      options
    );

useGetUsersWorkingTodayQuery.getKey = (variables: GetUsersWorkingTodayQueryVariables) => ['getUsersWorkingToday', variables];
;
